// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"b850684f","80":"fcde024c","518":"0296db37","672":"1d4fbc87","699":"efe860ab","716":"4d374356"}[chunkId] + ".chunk.js";
};